module.exports = __webpack_public_path__ + "static/media/404-error.763de752.svg";